const div = document.createElement('div');

export function escapeHtml(txt: string): string {
    div.innerText = txt;
    const escaped = div.innerHTML;
    div.innerHTML = ''; // let's do not leave any text in any random variable..
    return escaped;
}
